import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';
import { environment } from 'environments/environment';
import { OtrasGestionesProveedorService } from 'app/services/otras-gestiones-proveedor.service';
import { MensajesHtmlComponent } from 'app/main/private/mensajes-html/mensajes-html.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-form-consultas',
  templateUrl: './form-consultas.component.html',
  styleUrls: ['./form-consultas.component.scss']
})
export class FormConsultasComponent implements OnInit {

  formularioConsultas: FormGroup;
  dataBreadcumbPages: Array<any> = [];
  dataBreadcumbTitle: any;
  sessionId: string;
  cuit: string;
  apellidoNombreProveedor: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _loginService: LoginService,
    private _otrasGestionesProveedorService: OtrasGestionesProveedorService,
    private _snackBar: MatSnackBar
  ) { 
    this.dataBreadcumbPages = [
      { page: 'Otras gestiones', route: '/proveedores/otras-gestiones' }
    ];
    this.dataBreadcumbTitle = [
      { page: 'Consultas', route: '/proveedores/otras-gestiones/consultas-proveedor' }
    ];
  }

  ngOnInit(): void {
    // Verificar autenticación
    this._loginService.getAll().subscribe(resp => {
      if(!resp['isLogged'])
          this.router.navigate(['/login']);

      // Obtener datos de sesión y almacenarlos
      this._loginService.getSessionData().subscribe(response => {
        if (!response['rol'] || response['rol'] != 'PRVGRL')
            this.router.navigate(['/login']);
        
        //console.log('login service get session data, resp:', response); 
        // Almacenar datos de sesión en variables del componente
        this.sessionId = response['session_id'];
        this.cuit = response['cuit'];
        this.apellidoNombreProveedor = response['razon_social'];
      });
    });

    // Inicializar formulario
    this.formularioConsultas = this.fb.group({
      observaciones: ['', [Validators.required, Validators.maxLength(600)]]
    });
  }

  linkPanel() {   
    window.location.href = environment.urlWebSitePhp + 'site/inicio';
  }

  onSubmit() {
    this.formularioConsultas.markAllAsTouched();
    
    if (this.formularioConsultas.valid) {
      const observaciones = this.formularioConsultas.get('observaciones')?.value;
      //console.log('Consulta enviada:', observaciones);

      const formData = new FormData();
      formData.append('observaciones', observaciones);
      formData.append('sessionId', this.sessionId);
      formData.append('cuit', this.cuit);
      formData.append('razonSocial', this.apellidoNombreProveedor);


      this._otrasGestionesProveedorService.sendFormConsultas(formData).subscribe(
        resp => {
            //console.log('Consulta de facturación enviada:', resp);
            
            // Obtener el número de incidente de la respuesta
            let numIncidente = resp['body'] || resp['incidente'] || resp['numero']; 
            
            // Mostrar snackbar con opción de copiar
            this._snackBar.openFromComponent(MensajesHtmlComponent, {
              duration: undefined,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              data: ['consultaProveedor', numIncidente]
            });
            
           
            this.formularioConsultas.reset();
          },
          err => {
            this._snackBar.open('Ha ocurrido un error: ' + (err['message'] || 'Error desconocido'), 'Cerrar', {
              duration: undefined,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        );
    } else {
        // Mostrar mensaje de validación
        this._snackBar.open('Recordá que debes completar todos los campos correctamente', 'Cerrar', {
          duration: undefined,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
    }
      
      
  }

  goBack() {
    this.router.navigate(['/proveedores/otras-gestiones']);
  }
}
